import { render, staticRenderFns } from "./MRadio.vue?vue&type=template&id=06427482&scoped=true"
import script from "./MRadio.vue?vue&type=script&lang=js"
export * from "./MRadio.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06427482",
  null
  
)

export default component.exports